<div class="section">
  <h3>{{ 'account.wishlists.widget.heading' | translate }}</h3>
  <div class="loading-container mt-auto">
    @if ((wishlistLoading$ | async) !== true) { @if (allWishlistsItemsSkus$ | async; as wishlistsItemsSkus) { @if
    (wishlistsItemsSkus.length > 0) {
    <ng-container class="section">
      <div class="product-list" data-testing-id="wishlistProductsList">
        <ish-products-list
          [productSKUs]="wishlistsItemsSkus"
          listStyle="carousel"
          listItemStyle="tile"
          [listItemConfiguration]="tileConfiguration"
        />
      </div>
    </ng-container>
    } @else {
    <p>{{ 'account.wishlists.no_items' | translate }}</p>
    } }
    <a routerLink="/account/wishlists" data-testing-id="emptyWishlistProductsList">{{
      'account.overview.wishlist.view_all' | translate
    }}</a>
    } @else {
    <ish-loading />
    }
  </div>
</div>
